import apiClient from './apiClient';

export interface Role {
  id: string;
  name: string;
  description?: string;
}

export const roleService = {
  async getAllRoles(): Promise<Role[]> {
    const response = await apiClient.get('/api/roles');
    return response.data;
  },

  async getRoleById(id: string): Promise<Role> {
    const response = await apiClient.get(`/api/roles/${id}`);
    return response.data;
  },
};

export default roleService;
